export const IconAttachment: {
  name: 'icon_attachment-8f2860ad61af'
} = {
  name: 'icon_attachment-8f2860ad61af'
}
